// Normalize voting Entry image aliases for auction galleries and Demo snapshots.
// Accepts URL strings only and removes blanks/duplicates in display order.
export const getEntryImageUrls = (entry = {}) => [...new Set([
  entry.imageUrl,
  entry.imgUrl,
  entry.photoUrl,
  ...(Array.isArray(entry.images) ? entry.images : []),
  ...(Array.isArray(entry.imageUrls) ? entry.imageUrls : []),
].filter((url) => typeof url === "string" && url.trim()).map((url) => url.trim()))];
